import { render, staticRenderFns } from "./ItemOptionsRevised.vue?vue&type=template&id=5a53dbe7&scoped=true&"
import script from "./ItemOptionsRevised.vue?vue&type=script&lang=js&"
export * from "./ItemOptionsRevised.vue?vue&type=script&lang=js&"
import style0 from "./ItemOptionsRevised.vue?vue&type=style&index=0&id=5a53dbe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a53dbe7",
  null
  
)

export default component.exports